import { Redirect, Stack, router, useLocalSearchParams } from 'expo-router';
import * as React from 'react';
import { ActivityIndicator, View } from 'react-native';

import { RoutePlanner } from '@/components/routes/route-planner';
import { useSession } from '@/components/session-provider';
import { useTenant } from '@/components/tenant-provider';
import { memberTenantsForUser } from '@/lib/tenant';

export default function NewRouteScreen() {
  const [isFullscreen, setIsFullscreen] = React.useState(true);
  const { editor, event, tenant } = useLocalSearchParams<{
    editor?: 'member' | 'operator';
    event?: string;
    tenant?: string;
  }>();
  const { isAdmin } = useSession();
  const { activeTenant, isTenantLoading, memberships, tenants } = useTenant();
  const availableTenants = memberTenantsForUser(tenants, memberships, isAdmin);
  const selectedTenant =
    availableTenants.find((item) => item.slug === tenant) ??
    availableTenants.find((item) => item.id === activeTenant?.id) ??
    availableTenants[0] ??
    null;

  if (isTenantLoading) {
    return (
      <View className="flex-1 items-center justify-center bg-background">
        <ActivityIndicator />
      </View>
    );
  }
  if (!selectedTenant) return <Redirect href="/app/routes" />;

  function finishRoute(routeVersionId: string) {
    if (!event) {
      router.replace('/app/routes');
      return;
    }
    const pathname = editor === 'member' ? '/app/events/edit/[id]' : '/admin/events/[id]';
    router.replace({ pathname, params: { id: event, routeVersionId } });
  }

  function exitCreator() {
    if (router.canGoBack()) {
      router.back();
      return;
    }
    router.replace('/app/routes');
  }

  return (
    <View className="flex-1 bg-background">
      <Stack.Screen
        options={{ headerShown: false, title: `Create route · ${selectedTenant.name}` }}
      />
      <RoutePlanner
        draftKey={`route-planner-draft:${selectedTenant.id}:${event ?? 'standalone'}`}
        isFullscreen={isFullscreen}
        onExit={exitCreator}
        onFullscreenChange={setIsFullscreen}
        onSaved={finishRoute}
        tenantId={selectedTenant.id}
        workspaceTitle={`Create route · ${selectedTenant.name}`}
      />
    </View>
  );
}
